import React from 'react'
import PropTypes from 'prop-types'
import toClass from 'recompose/toClass'
import { Modal, Form, Select } from 'antd'

const FormItem = Form.Item
const SelectOption = Select.Option

function AiAgentPlanComponent(props) {
  const { form, plans, loading, ...rest } = props
  const { getFieldDecorator } = form

  const record = props.record || {};
  const availablePlans = Array.isArray(record && record.plans) ? record.plans : [];
  const planName = record.planName;

  const isPlanDefined = planName && planName !== 'Not defined';

  return (
    <Modal
      centered
      title={isPlanDefined ? 'Change AI Agent Plan' : 'Define AI Agent Plan'}
      okText={isPlanDefined ? 'Change' : 'Define'}
      okButtonProps={{ loading }}
      {...rest}>
      <Form layout="vertical">
        <FormItem label="New plan" hasFeedback>
          {getFieldDecorator('plan', {
            rules: [{ required: true }],
          })(
            <Select placeholder="Select a plan">
              {availablePlans.map(plan => (
                <SelectOption key={plan} value={plan}>
                  {plan}
                </SelectOption>
              ))}
            </Select>
          )}
        </FormItem>
      </Form>
    </Modal>
  )
}

export const SetAiAgentsPlanModal = Form.create({})(toClass(AiAgentPlanComponent))

AiAgentPlanComponent.propTypes = {
  form: PropTypes.any,
  plans: PropTypes.arrayOf(PropTypes.string),
  loading: PropTypes.bool,
}
